module.exports = __webpack_public_path__ + "img/btn-back.60e0d426.png";